// extracted by mini-css-extract-plugin
module.exports = {"icon":"DropDownIcon-module_icon__GNZYEurV3nshaV9YcN7s"};